import './sass/style.scss';
// import './sass/woocommerce.scss';
import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery; 

require('./sass/plugins/owl/owl.carousel.scss');
require('./sass/plugins/owl/owl.theme.default.scss');
require('./css/jquery-fancybox.css');
require('readmore-js');
 

// require('./feed/resources/js/jquery-global');
require('./feed/resources/js/jquery-template');
require('./feed/resources/js/lwsreviews-feed'); 


require('./js/jquery.fancybox.js');
// require('./js/jquery-cookies.js');
// require('./js/cookies.js');
require('./js/compteur.js');
require('./js/scripts.js');
require('./js/owl.carousel.js'); 


// require('./js/ajax_add_to_cart.js');
